// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".history-compare-footer {\n  width: \"100%\";\n  display: flex;\n  align-items: center;\n  height: 36px;\n  justify-content: center;\n  text-align: center;\n}\n.history-compare-footer .state-checkbox .v-label {\n  font-size: 0.8rem;\n}\n.history-compare-footer .square {\n  display: inline-block;\n  height: 10px;\n  width: 10px;\n}\n.theme--dark.model-viewer .history-compare-footer {\n  background-color: #1c1e22;\n}", ""]);
// Exports
module.exports = exports;
